<div
  class="protocol-cell__row"
  [class.protocol-cell__row--excluded]="excludedFromCounter"
  cdkDropList
  cdkDropListSortingDisabled="true"
  *ngIf="label"
  [id]="label.id"
  [cdkDropListConnectedTo]="connectedDropLists"
  (cdkDropListDropped)="cropsLabelAdded.emit(label.id)"
  (contextmenu)="onContextMenu($event)"
  [matTooltip]="label.name | translate"
  [matTooltipDisabled]="!collapsed"
  matTooltipPosition="right"
>
  <div class="protocol-cell__label-column">
    <span class="protocol-cell__color-bar" [style.background-color]="label.color" aria-hidden="true"></span>
    <div class="protocol-cell__label-area" (click)="selectLabel.emit()">
      <span class="item-name" *ngIf="!collapsed">{{ label.name ?? label.id | translate }}</span>
      <button
        mat-icon-button
        class="exclude-btn"
        *ngIf="excludeable && !collapsed"
        (click)="$event.stopPropagation(); excludeFromCounter.emit()"
      aria-label="Toogle counter"
      [matTooltip]="'tooltip.add_remove_to_counter' | translate"
      [matTooltipShowDelay]="tooltipDelay"
      #excludeTooltip="matTooltip"
      (mouseleave)="excludeTooltip.hide()"
    >
      <i
        class="{{
          excludedFromCounter ? 'ri-increase-decrease-line' : 'ri-increase-decrease-fill'
        }}"
      >      </i>
      </button>
    </div>
  </div>
  <span
    class="protocol-cell__count-value"
    (click)="selectLabel.emit()"
    matBadgeSize="small"
    matBadgeColor="warn"
    [matBadgeHidden]="changeCount === 0"
    [matBadge]="changeCount"
    [class.protocol-cell__count-value--excluded]="excludedFromCounter"
  >
    <ts-loading-attribute [value]="loading ? undefined : (countDisplayValue | compactNumber)"></ts-loading-attribute>
  </span>
  <span
    *ngIf="!hidePercentage"
    class="protocol-cell__pct"
    (click)="selectLabel.emit()"
    [class.protocol-cell__pct--excluded]="excludedFromCounter"
  >
    <ts-loading-attribute [value]="loading ? undefined : percentageDisplay"></ts-loading-attribute>
  </span>
</div>
